import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Call = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M8.09015 9.12991C8.80614 10.547 9.75607 11.8762 10.9399 13.0601C12.1238 14.2439 13.453 15.1939 14.8701 15.9099L16.3173 14.4627C16.6383 14.1416 17.1364 14.0797 17.5264 14.3123L20.0164 15.7977C20.5712 16.1287 20.6664 16.8935 20.2095 17.3504L17.6308 19.9291C17.1302 20.4297 16.3981 20.6332 15.7263 20.41C14.4562 19.988 13.2215 19.4296 12.0451 18.7348C10.6827 17.9302 9.3985 16.9426 8.22795 15.7721C7.05739 14.6015 6.0698 13.3173 5.26517 11.9549C4.57036 10.7785 4.01198 9.54375 3.59003 8.27367C3.36684 7.60188 3.57032 6.86979 4.07088 6.36924L6.64962 3.7905C7.10648 3.33364 7.87126 3.42876 8.20227 3.98364L9.68771 6.47363C9.92033 6.86357 9.85837 7.36169 9.53731 7.68275L8.09015 9.12991Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.12002 3.25871C6.92006 2.45867 8.25931 2.62526 8.83897 3.59692L10.3254 6.08857C10.7328 6.77141 10.6242 7.6437 10.062 8.20593L9.0022 9.26575C9.64956 10.4373 10.4704 11.5393 11.4656 12.5344C12.4607 13.5296 13.5627 14.3504 14.7343 14.9978L15.7941 13.938C16.3563 13.3758 17.2286 13.2672 17.9114 13.6746L20.4031 15.161C21.3747 15.7407 21.5413 17.0799 20.7413 17.88L18.1608 20.4604C17.479 21.1423 16.4573 21.4415 15.4943 21.1216C14.1739 20.6829 12.8901 20.1024 11.6669 19.3799C10.2502 18.5432 8.91534 17.5166 7.69939 16.3006C6.48345 15.0847 5.45682 13.7498 4.6201 12.3331C3.89764 11.1099 3.31707 9.82609 2.87839 8.50566C2.55847 7.54268 2.85771 6.52102 3.53957 5.83916L6.12002 3.25871Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
